var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content",style:(_vm.mainContentViewHeight),attrs:{"id":"main-content"}},[_c('iframe',{ref:"iframe",attrs:{"id":"track_history","src":_vm.iframeUrl,"width":"100%","height":_vm.tableMaxHeight,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }